import { render, staticRenderFns } from "./OA.vue?vue&type=template&id=1e900252&scoped=true&"
import script from "./OA.vue?vue&type=script&lang=js&"
export * from "./OA.vue?vue&type=script&lang=js&"
import style0 from "./OA.vue?vue&type=style&index=0&id=1e900252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e900252",
  null
  
)

export default component.exports